var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"objectSearch"},[_c('VueSelect',{attrs:{"label":"name","options":_vm.objects,"on-change":_vm.selectObject,"placeholder":"Search"},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('ObjectImage',{attrs:{"object":option}}),_vm._v("\n      "+_vm._s(option.name)+"\n    ")]}}]),model:{value:(_vm.selectedObject),callback:function ($$v) {_vm.selectedObject=$$v},expression:"selectedObject"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8476f574","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ObjectSearch.vue
// module id = 78
// module chunks = 0